import { RootState } from "@/app/stores"
import { ICreateJobOpening, IJobOpening, IUpdateJobOpening } from "@/shared/api/employment"
import { createVacancy, deleteVacancy, getVacancy, updateVacancy } from "@/shared/api/employment/employment"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchCreateVacancy = createAsyncThunk<
    IJobOpening,
    ICreateJobOpening,
    { state: RootState }
>('updateVacancy/fetchCreateVacancy', async (data, thunkAPI) => {
    try {
        const response = await createVacancy(data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchUpdateVacancy = createAsyncThunk<
    IJobOpening,
    IUpdateJobOpening,
    { state: RootState }
>('updateVacancy/fetchUpdateVacancy', async (data, thunkAPI) => {
    try {
        const { currentVacancy } = thunkAPI.getState().updateVacancy
        const response = await updateVacancy(currentVacancy.id, data)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchCurrentVacancy = createAsyncThunk<
    IJobOpening,
    void,
    { state: RootState }
>('updateVacancy/fetchCurrentVacancy', async (_, thunkAPI) => {
    try {
        const { currentVacancy } = thunkAPI.getState().updateVacancy
        const response = await getVacancy(currentVacancy.id)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDeleteVacancy = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('updateVacancy/fetchDeleteVacancy', async (_, thunkAPI) => {
    try {
        const { currentVacancy } = thunkAPI.getState().updateVacancy
        const response = await deleteVacancy(currentVacancy.id)
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})